import { find } from "utils/dom"

const initializePageHome = () => {

	const Home = find("[js-page='home']")
	if (!Home) return
    document.addEventListener("DOMContentLoaded", function () {
        const categoriaSelecionada = document.getElementById("categoriaSelecionada");
        const menuCategorias = document.getElementById("menuCategorias");
        const categoriaTexto = document.getElementById("categoriaTexto");
        const iconeAbrir = document.getElementById("iconeAbrir");
        const iconeFechar = document.getElementById("iconeFechar");
        const botoesCategoria = document.querySelectorAll(".categoria-item");
        const fecharMenu = document.getElementById("fecharMenu");
        const botoesBanner = document.querySelectorAll(".banner-btn");
        const slides = document.querySelectorAll(".swiper-slide");
        const indicadorMobile = document.querySelector(".indicador"); // Indicador do mobile
        const swiper = document.querySelector(".swiper-container")?.swiper;

        const tempoSlide = 6000; // Tempo de exibição do banner (6s)
        let intervalo; // Armazena o temporizador do autoplay
        let categoriaAtualIndex = 0; // Índice da categoria atual, começa do primeiro item

        // Função para encontrar a categoria correspondente ao slug na URL
        function getCategoriaBySlug(slug) {
            return [...botoesCategoria].find((botao, index) => {
                return botao.dataset.categoria === slug;
            });
        }

        // Função para obter o slug da URL
        function getSlugFromURL() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('categoria'); // Obtém o parâmetro 'categoria' da URL
        }

        function abrirMenu() {
            menuCategorias.classList.remove("hidden");
            setTimeout(() => menuCategorias.classList.remove("opacity-0"), 10);
            iconeAbrir.classList.add("hidden");
            iconeFechar.classList.remove("hidden");
        }

        function fecharMenuCategorias() {
            menuCategorias.classList.add("opacity-0");
            setTimeout(() => menuCategorias.classList.add("hidden"), 300);
            iconeAbrir.classList.remove("hidden");
            iconeFechar.classList.add("hidden");
        }

        categoriaSelecionada?.addEventListener("click", function (event) {
            event.stopPropagation();
            if (menuCategorias.classList.contains("hidden")) {
                abrirMenu();
            } else {
                fecharMenuCategorias();
            }
        });

        fecharMenu?.addEventListener("click", function () {
            fecharMenuCategorias();
        });

        botoesCategoria.forEach(botao => {
            botao.addEventListener("click", function () {
                // Atualiza o índice da categoria
                categoriaAtualIndex = parseInt(botao.dataset.index);
                const categoriaNome = botao.dataset.categoria;
                categoriaTexto.textContent = categoriaNome; // Atualiza o nome da categoria no mobile
                fecharMenuCategorias();

                // Atualiza o Swiper para exibir a categoria correspondente
                if (swiper) {
                    swiper.slideTo(categoriaAtualIndex); // Move para o slide correspondente
                }
            });
        });

        document.addEventListener("click", function (event) {
            if (!categoriaSelecionada?.contains(event.target) && !menuCategorias.contains(event.target)) {
                fecharMenuCategorias();
            }
        });

        // Função para iniciar animações e sincronizar indicadores
        function iniciarAnimacoes(index) {
            // Reseta o intervalo anterior antes de iniciar um novo
            clearInterval(intervalo);

            botoesBanner.forEach(btn => btn.classList.remove("ativo"));
            botoesBanner[index]?.classList.add("ativo");

            // Atualiza o nome da categoria no mobile
            if (botoesBanner[index]) {
                categoriaTexto.textContent = botoesBanner[index].dataset.categoria;
            }

            // Resetando e ativando a barra de progresso no desktop
            document.querySelectorAll(".categoria-indicador").forEach(el => {
                el.style.transition = "none";
                el.style.width = "0%";
            });

            setTimeout(() => {
                const indicador = botoesBanner[index]?.querySelector(".categoria-indicador");
                if (indicador) {
                    indicador.style.transition = `width ${tempoSlide}ms linear`;
                    indicador.style.width = "100%";
                }
            }, 50);

            // Atualizando o indicador no mobile corretamente
            if (indicadorMobile) {
                indicadorMobile.style.transition = "none";
                indicadorMobile.style.width = "0%";
                
                setTimeout(() => {
                    indicadorMobile.style.transition = `width ${tempoSlide}ms linear`;
                    indicadorMobile.style.width = "100%";
                }, 50);
            }

            // Resetando e aplicando animação de zoom
            slides.forEach(slide => {
                const img = slide.querySelector("img");
                img.style.transition = "none";
                img.style.transform = "scale(1)";
            });

            const slideAtivo = slides[index]?.querySelector("img");
            if (slideAtivo) {
                setTimeout(() => {
                    slideAtivo.style.transition = `transform ${tempoSlide}ms ease-in-out`;
                    slideAtivo.style.transform = "scale(1.05)";
                }, 50);
            }

            // Inicia o temporizador para trocar automaticamente de slide
            intervalo = setTimeout(() => {
                // Sempre segue a ordem sequencial após a categoria ativa
                categoriaAtualIndex = (categoriaAtualIndex + 1) % slides.length; // Se for o último, volta para o primeiro
                if (swiper) {
                    swiper.slideTo(categoriaAtualIndex);
                }
            }, tempoSlide);
        }

        // Inicia a barra e animação na primeira categoria ativa
        let categoriaSlug = getSlugFromURL(); // Obtém o slug da URL
        let categoriaEncontrada = getCategoriaBySlug(categoriaSlug); // Procura a categoria com base no slug

        if (categoriaEncontrada) {
            categoriaAtualIndex = parseInt(categoriaEncontrada.dataset.index); // Define o índice da categoria no swiper
            categoriaTexto.textContent = categoriaSlug; // Atualiza o texto da categoria no mobile
            swiper.slideTo(categoriaAtualIndex); // Muda o slide para a categoria correspondente
        } else {
            categoriaAtualIndex = 0; // Caso não encontre o slug, começa do primeiro slide
        }

        iniciarAnimacoes(categoriaAtualIndex); // Inicia a animação do slide

        // Atualiza a sequência dos slides com a ordem de navegação correta
        swiper?.on("slideChange", function () {
            categoriaAtualIndex = swiper.realIndex; // Atualiza o índice da categoria atual
            iniciarAnimacoes(categoriaAtualIndex);
        });
    });
};

export default initializePageHome;
